import React from 'react';
export function Guarantee() {
  return <section className="py-6 sm:py-8 px-4 bg-brand-cream" data-id="element-90">
      <div className="max-w-xl mx-auto" data-id="element-91">
        <div className="bg-white border border-brand-sage/30 p-6 sm:p-8 rounded-2xl text-center shadow-sm" data-id="element-92">
          <h3 className="text-lg sm:text-xl font-serif font-bold text-brand-text-main mb-3" data-id="element-93">
            🛡️ Ihre Investition ist 100% geschützt
          </h3>
          <h4 className="text-sm sm:text-base font-bold text-brand-olive mb-3" data-id="element-94">
            Vollständige 30-Tage-Geld-zurück-Garantie
          </h4>
          <p className="text-xs sm:text-sm text-brand-text-muted font-medium leading-relaxed" data-id="element-95">
            Sie haben 30 volle Tage, um alles zu testen. Nicht zufrieden? Volle
            Rückerstattung — ohne Fragen. Null Risiko für Sie. 100% Engagement
            unsererseits.
          </p>
        </div>
      </div>
    </section>;
}